import React from "react";

// You can replace these with real icons or components
const sportsData = [
  { name: "Watch Live", iconClass: "watchlive", badge: null, href: "#" },
  { name: "All Games", iconClass: "allgames", badge: null, href: "#", active: true },
  { name: "Cricket", iconClass: "sportcricket", badge: 0, href: "#" },
  { name: "Soccer", iconClass: "sportsoccer", badge: 0, href: "#" },
  { name: "Tennis", iconClass: "sporttennis", badge: 1, href: "#" },
  { name: "Horse", iconClass: "sporthorse", badge: 1, href: "#" },
  { name: "GreyHound", iconClass: "sportgreyhound", badge: 0, href: "#" },
];

const InPlayHeader = () => {
  return (
    <div className="live-match">
      <div className="sub_path center-box crname text-center py-2">
        <p className="text-lg font-semibold">In-Play</p>
      </div>

      <div className="game-wrap col3 mb-0">
        <div className="middle-in-play-white-bg inplay-scroll-menu overflow-x-auto bg-white rounded-md">
          <ul className="in-play-top flex space-x-4 p-2">
            {sportsData.map((item, index) => (
              <li key={index} className="w-20 text-center relative">
                <a
                  href={item.href}
                  className={`flex flex-col items-center ${
                    item.active
                      ? "text-blue-600 font-bold"
                      : "text-gray-700 hover:text-blue-600"
                  }`}
                >
                  {item.badge !== null && (
                    <span className="absolute top-0 right-3 text-xs bg-red-500 text-white px-1 rounded-full">
                      {item.badge}
                    </span>
                  )}
                  <span
                    className={`sports-icon ${item.iconClass} w-6 h-6 bg-gray-400 mb-1`}
                  ></span>
                  <span className="inplay-place text-sm">{item.name}</span>
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default InPlayHeader;
